import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import { loginFacebookSendForm } from 'src/app/redux/actions/login/login';
import Facebook from 'src/app/components/Facebook';
import 'src/app/containers/Login/LoginFormButtonsContainer.scss';


const LoginFormButtonsContainer = ({ loading, dispatch, location }) => {
  const loginFacebook = (event) => {
    event.preventDefault();
    dispatch(loginFacebookSendForm());
  };

  return (
    <div styleName="actions">

      <Link title="Resetuj hasło"
            styleName="actions__reset-link"
            to={ { pathname: '/przypomnij-haslo', search: location.search } }
      >
        Zapomniałeś hasła?
      </Link>

      <button styleName="actions__submit"
              data-test="button-login"
              type="submit"
              disabled={ loading }
      >
        Zaloguj się
      </button>

      <button styleName="actions__facebook"
              data-test="button-login-facebook"
              onClick={ loginFacebook }
              disabled={ loading }
              type="button"
      >
        <Facebook />
        <span>Zaloguj się facebookiem</span>
      </button>
    </div>
  );
};

LoginFormButtonsContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired
  }).isRequired
};

const mapStateToProps = state => ({
  loading: state.loginReducer.loading
});

export default connect(mapStateToProps)(withRouter(LoginFormButtonsContainer));
